'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.supervisorService', [])

.factory('supervisorService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/Supervisor';

    // **** HttpGet
    service.getUserRequestsToAuthorize = function (activeDirectoryAccountUsername) {
        if (_.isUndefined(activeDirectoryAccountUsername)) activeDirectoryAccountUsername = '';

        return $http.get(baseUrl + '/AuthorizingUserRequest/UserRequest/ToAuthorize/' + activeDirectoryAccountUsername, {})
        .then(function (response) {
            return response.data;
        });
    }

    return service;
}]);
